<template>
	<div class="loginForm">
		<div class="title text-center mb-5">Giriş Yap</div>
		
		<v-text-field v-model="form.email" label="E-Mail" name="email" type="email" :prepend-inner-icon="mdiAccount" outlined />

		<v-text-field v-model="form.password" label="Parola" name="password" type="password" :prepend-inner-icon="mdiAccountKey" outlined  />


		<v-btn color="primary" block large depressed class="mb-5 " :disabled="!allIsWell" @click="login()" :loading="isSending">Giriş Yap</v-btn>

		<div class="text-center">
			<a href="">Şifremi unuttum</a>
		</div>


		<v-snackbar v-model="actionDialogShow" :color="actionDialogColor" :timeout="3000" top>
			{{ actionDialogText }}
			<v-btn dark text @click="actionDialogShow = false">
				Tamam
			</v-btn>
		</v-snackbar>
	</div>
</template>


<script>
    import {
        mdiAccount,
        mdiAccountKey,
    } from '@mdi/js';
    export default {
        name: "PageLogin",
        data: () => ({
            mdiAccount: mdiAccount,
			mdiAccountKey: mdiAccountKey,
			
            actionDialogShow: false,
            actionDialogText: "",
            actionDialogColor: "",

			isSending : false,
			form : {
				email : "",
				password : ""
			}
		}),
		methods:{
			login(){
				this.isSending = true;
				this.$http.post( process.env.VUE_APP_API_URL + "/auth/login", this.form).then(response => {  
					if(response.body.success){ 
						this.actionDialogShow = true;
						this.actionDialogText = "Giriş işlemi başarılı. Yönlendiriliyorsunuz"
						this.actionDialogColor = "green"
						this.$router.replace("/")
						location.reload();
					}
					else{ 
						this.actionDialogShow = true;
						this.actionDialogText = response.body.reason || "Giriş işlemi başarısız. Lütfen tekrar deneyin"
						this.actionDialogColor = "red"  
					} 
					this.isSending = false;
				}) 
			}
		},
		computed : {
			allIsWell(){
				if(this.form.email == "" || this.form.password == ""){
					return false;
				}
				return true;
			}
		}
		
    }
</script>